// TODO internationalisation?
export const LOCALE = 'nl';
